import React from 'react';
import { AudioQuality, AUDIO_QUALITY_LABELS } from '../../../types/annotation';

interface AudioQualitySelectorProps {
  value: AudioQuality | null;
  onChange: (v: AudioQuality) => void;
  disabled?: boolean;
}

const AUDIO_QUALITY_ORDER: AudioQuality[] = [
  'clear',
  'low_background_noise',
  'moderate_noise',
  'heavy_noise',
  'wind_noise',
  'microphone_distortion',
];

const AudioQualitySelector: React.FC<AudioQualitySelectorProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <select
      value={value ?? ''}
      onChange={(e) => {
        if (e.target.value) onChange(e.target.value as AudioQuality);
      }}
      disabled={disabled}
      className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-transparent bg-white disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <option value="">— Select audio quality —</option>
      {AUDIO_QUALITY_ORDER.map((quality) => (
        <option key={quality} value={quality}>
          {AUDIO_QUALITY_LABELS[quality]}
        </option>
      ))}
    </select>
  );
};

export default AudioQualitySelector;
